import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet, View } from 'react-native';

import { RivieraLogo } from '@/components/riviera-logo';
import { useTheme } from '@/hooks/use-theme';

/**
 * On-brand fallback for cards and heroes whose record has no image — most of
 * the AWIN/Fnac events ship without a poster. A soft "sky over sea" gradient
 * (warm accent → cool muted, both theme-aware) behind the Riviera
 * sun-and-waves mark, instead of the flat muted box these used to show.
 *
 * Fills its positioned parent (the card's fixed-height imageBox or the detail
 * hero), so it drops straight in where the old `<View backgroundColor>` was.
 */
export function NoImagePlaceholder({ size = 72 }: { size?: number }) {
  const theme = useTheme();
  return (
    <LinearGradient
      colors={[theme.accent, theme.muted]}
      start={{ x: 0.5, y: 0 }}
      end={{ x: 0.5, y: 1 }}
      style={styles.fill}>
      <View style={styles.mark}>
        <RivieraLogo size={size} color={theme.gold} />
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  fill: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Softens the mark so it reads as a watermark, not foreground content.
  mark: {
    opacity: 0.85,
  },
});
